// viewModalLabels.js

import { getPluralLabel, getSingularLabel } from 'utilities/Languages';

// Builds the optional "include descendants" label for the checkbox.
// Returns an empty string when the label should be hidden.
export const buildIncludeDescendantsLabel = ({
    nodeKey,
    typeKey,
    parentTypeKey,
    getType,
    language,
}) => {
    if (!nodeKey || !typeKey || !parentTypeKey) return '';
    const activeDef = getType(typeKey);
    const parentDef = getType(parentTypeKey);
    const activePlural = getPluralLabel(activeDef, typeKey, language);
    const parentSingular = getSingularLabel(parentDef, parentTypeKey, language);
    if (!activePlural || !parentSingular) return '';
    return `Include all ${activePlural.toLowerCase()} connected to this ${parentSingular.toLowerCase()}`;
};
